import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { ChevronRight } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { initiateTransportOrderCreate, initiateTransportOrderEdit, setNewTransportOrderValue } from '../../actions';
import { selectNewTransportOrder, selectTransportOrder } from '../../selectors';

import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { selectConfig, selectWorks } from '../../../Api/selectors';
import { REQUEST_TRANSPORT_ORDER } from '../../constants';

import cn from 'classnames';
import { CreateTransportOrderModal } from './CreateTransportOrderModal';
import { fetchCompany } from '../../../Companies/actions';
import LoadingField from '../../../../containers/App/Components/LoadingField/LoadingField';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { HBox, VBox } from '../../../../components/Box';
import { selectCompany } from '../../../Companies/selectors';
import { Edit } from '../../../../components/Icon';

const STATE = {
  showCreateModal: false,
};

class TransportOrderCreateModalComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    // Only open the modal if the condition is truly needed.
    if (this.props.addVehicleModal) {
      this.setState({ showCreateModal: false });
    }
    if (this.props.forceOpen) {
      this.setState({ showCreateModal: true });
    }
    if (!this.props.homeCompany?.id) {
      this.props.fetchHomeCompany();
    }
  }

  get propertyNames() {
    return Object.keys(this.props.values);
  }

  reset() {}

  save(callback, saveStrategy) {}

  render() {
    // if (this.props.work) {
    //   return (
    //     <ModalComponent size={'modal-l'}>
    //       <HBox gap={12}>
    //         <VBox>
    //           <LoadingField />
    //           <LoadingField />
    //           <LoadingField />

    //         </VBox>
    //         <VBox>
    //           <LoadingField />
    //           <LoadingField />
    //           <LoadingField />

    //         </VBox>
    //       </HBox>
    //     </ModalComponent>
    //   );
    // }

    return (
      <>
        {this.state.showCreateModal && (
          <CreateTransportOrderModal
            onClose={() => {
              this.setState({ showCreateModal: false });
              this.props.onClose && this.props.onClose();
            }}
            vehicle={this.props.vehicle}
            vehicleId={this.props.vehicleId}
            from_location={this.props.from_location}
            addVehicleModal={this.props.addVehicleModal}
            transportOrderId={this.props.transportOrderId}
            transportOrder={this.props.transportOrder}
          />
        )}
        {window.innerWidth <= 768 && !this.props.overviewButton && (
          <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftAdd'}>
            {' '}
            +
          </ButtonComponent>
        )}
        {window.innerWidth >= 768 && !this.props.overviewButton && (
          <>
            <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftEdit'}>
              {' '}
              {this.props.transportOrderId ? <Edit /> : this.lbl('vehicle.overview.addNewButton')}
            </ButtonComponent>
          </>
        )}
        {window.innerWidth <= 768 && this.props.overviewButton && (
          <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftAdd'}>
            {' '}
            {this.props.transportOrderId ? this.lbl('task.progress.2') : this.lbl('vehicle.overview.addNewButton')}
          </ButtonComponent>
        )}
        {window.innerWidth >= 768 && this.props.overviewButton && (
          <>
            <ButtonComponent onClick={() => this.setState({ showCreateModal: true })} style={'ButtonSoftEdit'}>
              {' '}
              {this.props.transportOrderId ? this.lbl('task.progress.2') : this.lbl('vehicle.overview.addNewButton')}
            </ButtonComponent>
          </>
        )}
      </>
    );
  }
}

TransportOrderCreateModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_TRANSPORT_ORDER]),
    values: selectNewTransportOrder(),
    transportOrder: selectTransportOrder(ownProps?.transportOrderId),
    homeCompany: selectCompany(4),

    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateTransportOrderCreate());
    },
    initEdit() {
      dispatch(initiateTransportOrderEdit(ownProps.transportOrderId));
    },
    fetchHomeCompany() {
      dispatch(fetchCompany(4));
    },

    setValue(name, value) {
      dispatch(setNewTransportOrderValue(name, value));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderCreateModal = compose(withConnect, withRouter)(TransportOrderCreateModalComp);
